export default {
    CREATE_COMPLAINT: {
        url: "/api/v1/complaint",
        method: "post",
    },
    GET_ALL_COMPLAINTS: {
        url: "/api/v1/complaint",
        method: "get",
    },
    COMPLAINT_ASSIGN_BULK: {
        url: "/api/v1/complaint/assign",
        method: "put"
    },
    GET_COMPLAINT_CARDS: {
        url: "/api/v1/complaint/cards",
        method: "get"
    },
    GET_COMPLAINT_BY_ID: {
        url: "/api/v1/complaint/{id}",
        method: "get"
    },
    UPDATE_COMPLAINT_BY_ID: {
        url: "/api/v1/complaint/{id}",
        method: "put"
    },
}